<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck">Se va a eliminar el registro de la Black list, pulse "Confirmar" para
      continuar.</label>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal" aria-label="Close" @click="deleteData()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'UserDelete',
  props: [
    'id',
    'modalTitle',
    'class',
    'endpoint'
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
  methods: {
    deleteData(){
      axios.delete(`/customer/${this.endpoint}`)
        .then((response) => {
          console.log(response)
          this.$emit("refreshRegisterList", '');
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
